/** Mirrors the AI SDK `ChatStatus` union returned by `useChat`. */
export enum CopilotChatStatusEnum {
  SUBMITTED = "submitted",
  STREAMING = "streaming",
  READY = "ready",
  ERROR = "error",
}

/** Roles of an AI SDK `UIMessage`. */
export enum CopilotRoleEnum {
  SYSTEM = "system",
  USER = "user",
  ASSISTANT = "assistant",
}

/** Built-in AI SDK part types, on top of `data-*` and `tool-*`. */
export enum CopilotPartEnum {
  TEXT = "text",
  FILE = "file",
  REASONING = "reasoning",
  STEP_START = "step-start",
}

/**
 * Names of our custom blocks. A part streams in as `data-<name>`, so adding a bubble
 * means adding a member here and an entry in `COPILOT_BLOCKS`.
 */
export enum CopilotDataPartEnum {
  ANALYSIS = "analysis",
  RECAP = "recap",
  MISSING = "missing",
  ACTIONS = "actions",
  ERROR = "error",
  RESOURCES = "resources",
}

/** Resource destinations emitted by the assistant. Routing must depend on this value alone. */
export enum CopilotResourceKindEnum {
  COLLABORATOR_PROFILE = "collaborator_profile",
  TRAINING_PLAN_SESSION = "training_plan_session",
  EMPLOYEE_TRAINING = "employee_training",
  EMPLOYEE_REQUEST = "employee_request",
  COMPANY_REGISTRATION = "company_registration",
  COMPANY_REQUEST = "company_request",
  CATALOG_TRAINING = "catalog_training",
}

/** Tools the assistant may call. A call streams in as `tool-<name>`. */
export enum CopilotToolEnum {
  CREATE_TRAINING = "createTraining",
  UPDATE_TRAINING = "updateTraining",
  ADD_PROVIDER = "addProvider",
  CREATE_SESSION = "createSession",
  /**
   * Not approval-gated: runs server-side (draft training or update diff) and streams the review
   * payload as its output; the front opens the pre-filled training form from it.
   */
  REVIEW_TRAINING = "reviewTraining",
}

/** States of an AI SDK tool part — the action object's lifecycle. */
export enum CopilotToolStateEnum {
  INPUT_STREAMING = "input-streaming",
  INPUT_AVAILABLE = "input-available",
  APPROVAL_REQUESTED = "approval-requested",
  APPROVAL_RESPONDED = "approval-responded",
  OUTPUT_AVAILABLE = "output-available",
  OUTPUT_ERROR = "output-error",
  OUTPUT_DENIED = "output-denied",
}

/** Outcome of a `createSession` batch as the backend reports it; a single row is never partial. */
export enum CopilotSessionBatchStatusEnum {
  CREATED = "created",
  PARTIAL = "partial",
  FAILED = "failed",
}

/** Visual weight of a suggested action. */
export enum CopilotActionVariantEnum {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

export enum CopilotFeedbackEnum {
  UP = "up",
  DOWN = "down",
}

export enum CopilotDocTypeEnum {
  TRAINING_PROGRAM = "training_program",
  ATTENDANCE_SHEET = "attendance_sheet",
}

export enum CopilotChatTriggerEnum {
  SUBMIT = "submit-message",
  REGENERATE = "regenerate-message",
}
